import * as rd from '@devexperts/remote-data-ts'
import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import { setupByUrl } from '@/store/commonActions'

import { licenseSlice } from '@/store/licenseSlice'
import { getBookingFlowFromSearchParams } from '@/utils/bookingFlow'
import { bookingAvailabilitySlice } from '../store/bookingAvailabilitySlice'

import { useAppDispatch, useAppSelector } from './store'

export function useApp() {
  const dispatch = useAppDispatch()
  const routeParams = useParams()
  const license = useAppSelector(licenseSlice.selectors.licenseRemoteData)
  const [searchParams] = useSearchParams()

  useEffect(() => {
    dispatch(setupByUrl(window.location.href))
  }, [])

  useEffect(() => {
    if (routeParams.license && rd.isInitial(license)) {
      dispatch(licenseSlice.actions.loadLicense(routeParams.license))
      dispatch(licenseSlice.actions.loadMainTimeSlots(routeParams.license))
    }
  }, [license, routeParams])

  useEffect(() => {
    const bookingFlow = getBookingFlowFromSearchParams(searchParams)
    dispatch(
      bookingAvailabilitySlice.actions.load({
        bookingFlow,
      })
    )
  }, [])
}
